// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Send Email - extends Notification styles */
.send-email-stats {
  grid-template-columns: 1fr;
  max-width: 320px;
}

.send-email-to-wrap {
  position: relative;
}

.send-email-suggestions {
  list-style: none;
  padding: 0;
  margin: 0;
}

.send-email-suggest-header {
  padding: 0.6rem 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted, #64748b);
  background: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
}

.send-email-suggest-custom {
  padding: 0.75rem 1rem;
  font-size: 0.85rem;
  color: var(--text-muted, #64748b);
  background: #f8fafc;
  border-top: 1px solid #f1f5f9;
}

.send-email-suggest-empty {
  padding: 1rem;
  font-size: 0.9rem;
  color: var(--text-muted, #64748b);
  text-align: center;
}

.send-email-suggest-active {
  background: rgba(15, 118, 110, 0.08) !important;
}

.send-email-error {
  display: block;
  margin-top: 0.35rem;
  font-size: 0.8rem;
  color: #dc2626;
}

.send-email-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.send-email-btn-clear {
  padding: 0.75rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  color: var(--text, #475569);
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s;
}

.send-email-btn-clear:hover {
  background: #e2e8f0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Communication/SendEmailPage.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;EACjC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Send Email - extends Notification styles */\n.send-email-stats {\n  grid-template-columns: 1fr;\n  max-width: 320px;\n}\n\n.send-email-to-wrap {\n  position: relative;\n}\n\n.send-email-suggestions {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.send-email-suggest-header {\n  padding: 0.6rem 1rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-muted, #64748b);\n  background: #f8fafc;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.send-email-suggest-custom {\n  padding: 0.75rem 1rem;\n  font-size: 0.85rem;\n  color: var(--text-muted, #64748b);\n  background: #f8fafc;\n  border-top: 1px solid #f1f5f9;\n}\n\n.send-email-suggest-empty {\n  padding: 1rem;\n  font-size: 0.9rem;\n  color: var(--text-muted, #64748b);\n  text-align: center;\n}\n\n.send-email-suggest-active {\n  background: rgba(15, 118, 110, 0.08) !important;\n}\n\n.send-email-error {\n  display: block;\n  margin-top: 0.35rem;\n  font-size: 0.8rem;\n  color: #dc2626;\n}\n\n.send-email-actions {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.send-email-btn-clear {\n  padding: 0.75rem 1.25rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--text, #475569);\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.send-email-btn-clear:hover {\n  background: #e2e8f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
